import React from "react";
import { Utils } from '../../utils/Utils';
import { Loadding } from "../../lib/loadding/Loadding";
import "../../static/css/dialog.scss";
import { COURSE, COURSE_API } from "../../utils/Req";

const index = [1, 2, 3, 4, 5];
let retryFetchTime = 0;

export default class CourseScoreDialog extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			score: 0,
			showEnding: props.noNeedCommit,	// 不需要评论框，直接显示课程小结
			comment: '',
			encourageReport: null
		};
		this.reportUrl = "";
		this.project = Utils.getHashQueryString("project") || "";
		this.PutaoID = Utils.getCookie("putaoid");
		this.Token = encodeURIComponent(Utils.getCookie("token"));
	}

	componentWillMount() {
		if (this.state.showEnding) {
			this.showEndingHandler();
		}
	}

	//   显示上完课提醒
	showEndingHandler() {
		const that = this;
		if (window.medalOnOff) {
			that.getEncourageReport();
		} else {
			that.setState({
				showEnding: true
			});
		}
	}

	//   跳转
	changeLocation(url, noHomework) {
		if (window.location.href === url) {
			window.location.reload();
		} else {
			if (noHomework === 1) {
				if (this.reportUrl) {
					window.location.replace(this.reportUrl);
				} else {
					window.PuTaoA.showTips("学习报告生成中，请稍后再试！");
				}
			} else {
				window.location.replace(url);
			}
		}
	}

	//   发送评价
	sendComment(cid, noHomework) {
		const that = this;
		const { comment, score } = this.state;
		const req = `${COURSE_API.feedback}?putaoid=${that.PutaoID}&token=${that.Token}&cid=${cid}&comment=${encodeURIComponent(comment)}&score=${score}&from=pc`;

		fetch(req, { method: 'GET' }).then(res => res.json()).then(data => {
			if (data.code === 200) {
				that.showEndingHandler();
			}
		})

		if (noHomework === 1) {
			that.getReportUrl(cid);
		}

	}

	// 获取学习报告的url，有些课没有作业，直接引导去看报告 300_3_1
	getReportUrl(cid) {
		const that = this;
		retryFetchTime++;
		fetch(`${COURSE_API.get_reportUrl}?putaoid=${this.PutaoID}&token=${this.Token}&cid=${cid}&from=pc`, { method: 'GET' }).then(res => res.json()).then(data => {
			if (data && data.code === 200 && data.data && data.data.url) {
				that.reportUrl = data.data.url;
				if (that.project === "vipbingo") {
					that.reportUrl = that.reportUrl.replace("putaoabc.com", "aibingo.com.cn/bingo") + "&noshare=1&page=vipbingo"
				}
				retryFetchTime = 0;
			} else {
				if (retryFetchTime < 5) {
					setTimeout(() => {
						that.getReportUrl(cid);
					}, 500);
				}
			}
		}).catch((err) => {
			if (retryFetchTime < 5) {
				setTimeout(() => {
					that.getReportUrl(cid);
				}, 500);
			}
		})
	}

	// 获取主课完成-学习小结
	getEncourageReport() {
		const that = this;
		const { isBack, cid } = this.props;
		retryFetchTime++;
		fetch(`${COURSE_API.encourage_report}?putaoid=${that.PutaoID}&token=${that.Token}&cid=${cid}&from=pc&startTime=${window.startTime}&coursewareType=`, { method: 'GET' }).then(res => res.json()).then(data => {
			if (data && data.code === 200 && data.data) {
				that.setState({
					encourageReport: data.data,
					showEnding: true
				});
			} else {
				if (retryFetchTime < 3) {
					setTimeout(() => {
						that.getEncourageReport();
					}, 200);
				} else {
					isBack ? window.history.back() : this.changeLocation(`${window.location.pathname}${window.location.search}#/path?cid=${cid}`);
				}
			}
		}).catch((err) => {
			if (retryFetchTime < 3) {
				setTimeout(() => {
					that.getEncourageReport();
				}, 200);
			} else {
				isBack ? window.history.back() : this.changeLocation(`${window.location.pathname}${window.location.search}#/path?cid=${cid}`);
			}
		})
	}

	//   输入评价
	changeCommentHandler(e) {
		e.preventDefault();

		this.setState({
			comment: e.target.value
		})
	}

	render() {
		const { score, comment, showEnding, encourageReport } = this.state;
		const { cid, isBack, url, text, noHomework } = this.props;

		return (
			<div className="dialog">
				{!showEnding && (
					<div className="course-score-dialog-container">
						<div className="course-score-dialog-avator" />
						<div className="course-score-dialog-avator-bg" />
						<div className="course-score-dialog-title">您对本次学习内容还满意吗</div>
						<ul className="course-score-dialog-stars-container">
							{index &&
								Array.isArray(index) &&
								index.map(value => (
									<li
										key={value}
										className={
											value <= score
												? "course-score-dialog-star on"
												: "course-score-dialog-star"
										}
										onClick={() => {
											this.setState({ score: value });
										}}
									/>
								))}
						</ul>
						{score ? (
							<textarea
								className="course-score-dialog-text-input"
								placeholder="亲，如有不满意的地方，请在这里告诉我们， 期待您的建议～"
								value={comment}
								onChange={(e) => {
									this.changeCommentHandler(e);
								}}
							/>
						) : null}

						<div className="course-score-dialog-button-container">
							<div
								className="course-score-dialog-button-cancel"
								onClick={() => {
									this.showEndingHandler();
								}}
							>取消</div>
							<div
								className="course-score-dialog-button-sure"
								onClick={() => {
									this.sendComment(cid, noHomework);
								}}
							>确定</div>
						</div>
					</div>
				)}

				{showEnding ?
					window.medalOnOff && !window.isDev ?
						(encourageReport ?
							<div className="class-end-dialog-container">
								<div className="class-end-dialog-title" />
								<div className="class-end-dialog-content">
									<ul className='give-star'>
										<li className={encourageReport.starNum > 0 ? 'add-star' : ''} />
										<li className={encourageReport.starNum > 1 ? 'add-star' : ''} />
										<li className={encourageReport.starNum > 2 ? 'add-star' : ''} />
										<li className={encourageReport.starNum > 3 ? 'add-star' : ''} />
										<li className={encourageReport.starNum > 4 ? 'add-star' : ''} />
									</ul>
									<div className="score-detail">
										<div className="score-cell">
											<div><span>{encourageReport.totalNum || 0}</span>次</div>
											<div>与老师互动</div>
										</div>
										<div className="score-cell">
											<div><span>{encourageReport.speechNum || 0}</span>次</div>
											<div>听说发音</div>
										</div>
										<div className="score-cell">
											<div><span>{encourageReport.screenNum || 0}</span>次</div>
											<div>识记答题</div>
										</div>
										<div className="score-cell">
											<div><span>{encourageReport.knowledgeRatio || 0}</span>%</div>
											<div>答对</div>
										</div>
									</div>
									<div className="end-integrals">本次获得<span className="integrals-icon">{encourageReport.integrals || 0}</span></div>
									{
										encourageReport.medalIds && encourageReport.medalIds && encourageReport.medalIds.length ?
											<ul className="medal">
												{
													encourageReport.medalIds.map((value, index) => {
														return <li key={index}><img src={`https://webres.putaoabc.com/course/images/medal/medal-${value}_s80.png`} /></li>
													})
												}
											</ul>
											:
											<div className="no-medal">没有获取任何勋章，继续加油吧！</div>
									}
								</div>
								<div className="class-end-dialog-button-container">
									<div
										className="class-end-dialog-button-cancel"
										onClick={() => {
											isBack ? window.history.back() : this.changeLocation(`${window.location.pathname}${window.location.search}#/path?cid=${cid}`);
										}}
									/>
									<div
										className="class-end-dialog-button-sure"
										onClick={() => {
											this.changeLocation(url, noHomework);
										}}
									>{text}</div>
								</div>
							</div> :
							<Loadding type="full" name="typing_loader" />
						)
						:
						<div className="class-end-dialog-container-old">
							<div className="class-end-dialog-title">好棒！上完啦</div>
							<div className="class-end-dialog-picture" />
							<div className="class-end-dialog-button-container">
								<div
									className="class-end-dialog-button-cancel"
									onClick={() => {
										isBack ? window.history.back() : this.changeLocation(`${window.publicUrl}?v=${window.pt_vid}#/path?cid=${cid}`);
									}}
								>返回</div>
								<div
									className="class-end-dialog-button-sure"
									onClick={() => {
										this.changeLocation(url, noHomework);
									}}
								>{text}</div>
							</div>
						</div>
					: null}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/dialog/course.js